// @import "node_modules/@se/web-ui/styles/_theme.scss";
@import "../../../styles/variables.scss";

.faq-widget {
  background-color: #ffffff;
  padding: var(--qds-panel-subsection-padding, 16px)
    var(--qds-panel-padding, 20px);
  border: 1px solid var(--qds-theme-divider-subdued, #ced3d6);
  border-radius: var(--qds-panel-border-radius, 12px);
  margin-top: 20px;
  color: #333333;
}

.faq-widget--uiaas {
  @extend .faq-widget;
}

.faq-widget--dashboard {
  margin: 0;

  @media (max-width: $uiaas-tablet) {
    box-shadow: none;
  }
}

.faq-widget--uiaas[dir="rtl"] {
  @media (min-width: $uiaas-tablet) {
    margin-left: 0;
    margin-right: 0;
  }
}

.highlight {
  font-weight: bold;
}

.faq-answer-text {
  padding: 0;
  margin: 0 0 20px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: break-spaces;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-clamp: 4;
}
